import React from "react";
import { useTracking } from "react-tracking";
import { TrackingData, dispatch } from "common/helpers/Analytics";
import { useSelector } from "react-redux";
import { currentUser, currentUserOrgId } from "common/selectors/user.selectors";
import { useLocation } from "react-router";
import { UAParser } from "ua-parser-js";

interface TrackingProps {
  children: React.ReactNode;
}

export const Tracking: React.FC<TrackingProps> = ({ children }) => {
  // Selectors
  const user = useSelector(currentUser);
  const orgId = useSelector(currentUserOrgId);

  // Hooks
  const location = useLocation();
  const { Track, trackEvent } = useTracking<TrackingData>(
    { userId: user?.id, orgId, page: location.pathname },
    {
      dispatch,
    },
  );

  React.useEffect(() => {
    const parser = new UAParser();
    trackEvent({ hitType: "pageview", page: location.pathname, userAgent: parser.getResult() });
  }, [location.pathname, trackEvent]);

  // @ts-ignore
  return <Track>{children}</Track>;
};
